import { render, staticRenderFns } from "./BlackListContactActions.vue?vue&type=template&id=5a3a1b32&"
import script from "./BlackListContactActions.vue?vue&type=script&lang=ts&"
export * from "./BlackListContactActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports